"use client";

/**
 * SetupHelpLink - the funnel's way to reach support where the chat launcher is hidden
 *
 * On /setup the floating chat launcher is hidden wherever it would sit on a step's primary button, the pay
 * button included: below 992 px, and below 1176 px on the full-width plan and card steps (`wide`); the
 * widths are explained in SetupClientProviders and must stay in step with it. This quiet line in normal
 * flow, under the step, opens the messenger instead, loading it on demand. Not shown where the launcher
 * is visible, or on /app/setup (the dashboard keeps its own launcher).
 */
import { c as _c } from "react/compiler-runtime";
import { usePathname } from "next/navigation";
import { T } from "gt-next";
import { openIntercomChat, SETUP_PATH } from "@/components/intercom/IntercomProvider";
export default function SetupHelpLink(t0) {
  const $ = _c(3);
  const {
    wide: t1
  } = t0;
  const wide = t1 === undefined ? false : t1;
  const pathname = usePathname();
  if (!SETUP_PATH.test(pathname ?? "")) {
    return null;
  }
  const t2 = `mt-4 text-center text-xs text-black/40 ${wide ? "min-[1176px]:hidden" : "lg:hidden"}`;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <T>Need help?{" "}<button type="button" onClick={_temp} className="relative cursor-pointer underline underline-offset-2 transition-colors duration-150 after:absolute after:-inset-x-2 after:-inset-y-3.5 after:content-[''] hover:text-black/60 focus-visible:rounded-sm focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black/40">Chat with us</button></T>;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== t2) {
    t4 = <p className={t2}>{t3}</p>;
    $[1] = t2;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  return t4;
}
function _temp() {
  return openIntercomChat();
}